<template>
  <div>
    <h1 class="mb-0">Nueva contraseña</h1>
    <p>Ingrese y confirme su nueva contraseña.</p>
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form class="mt-4" novalidate @submit.prevent="handleSubmit(onSubmit)">
        <ValidationProvider
          vid="email"
          name="Correo electrónico"
          rules="required|email"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <label for="rut">Correo electrónico</label>
            <input
              type="text"
              :class="
                'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
              "
              id="email"
              name="email"
              v-model="user.email"
              placeholder="Ingrese su correo electrónico"
              required
            />
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <!-- PASSWORD -->
        <ValidationProvider
          vid="password"
          name="Contraseña"
          rules="required|confirmed:password_confirmation"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <label for="password">Contraseña</label>
            <input
              type="password"
              v-model="user.password"
              :class="
                'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
              "
              id="password"
              placeholder="Contraseña"
            />
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <!-- CONFIRM PASSWORD -->
        <ValidationProvider
          vid="password_confirmation"
          name="Confirmar contraseña"
          rules="required|min:8"
          v-slot="{ errors }"
        >
          <div class="form-group">
            <label for="password">Contraseña</label>
            <input
              type="password"
              v-model="user.password_confirmation"
              :class="
                'form-control mb-0' + (errors.length > 0 ? ' is-invalid' : '')
              "
              id="password_confirmation"
              placeholder="Confirmar Contraseña"
            />
            <div class="invalid-feedback">
              <span>{{ errors[0] }}</span>
            </div>
          </div>
        </ValidationProvider>
        <div class="d-inline-block w-100">
          <button
            type="submit"
            :disabled="isLoading"
            class="btn btn-primary float-right"
          >
            <span v-if="isLoading">
              <b-spinner small type="grow"></b-spinner>
              Cargando...
            </span>
            <span v-else> Restablecer contraseña </span>
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { core } from "@/config/pluginInit";
export default {
  name: "RecoverPassword",
  mounted() {
    this.user.token = this.$route.params.token;
    this.user.email = this.$route.query.email;
  },
  data: () => ({
    user: {
      token: "",
      email: "",
      password: "",
      password_confirmation: "",
    },
  }),
  methods: {
    ...mapActions({
      restorePassword: "restorePassword",
    }),
    async onSubmit() {
      const resp = await this.restorePassword(this.user);
      if (resp?.status == 200) {
        core.showSnackbar("success", resp.data.message);
        this.$router.push("/auth/login");
      }
    },
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
  },
};
</script>
